module.exports = __webpack_public_path__ + "static/img/154_TO8_1873.72a4529.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/154_TO8_1873.jpg
// module id = yRTE
// module chunks = 0